import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { map } from 'rxjs';
import { PaymentService } from '@core/payments/services/payment.service';
import { ThemeService } from '@shared/services/theme.service';
import * as CryptoJS from 'crypto-js';
@Component({
    selector: 'app-load-page',
    templateUrl: './load-page.component.html',
    styleUrls: ['./load-page.component.css'],
    standalone: false
})
export class LoadPageComponent implements OnInit {
  private transactionIdentifier: string = '';
  private token: string = '';
  private canEnrAutPay: string = '';
  private canRegCard: string = '';
  private phoneNumber: string = '';
  private onlyLinkAutomaticDebit: string = '';
  private uploadCard: boolean = false;
  private currencySymbol: string = '';
  carga1: any;
  carga2: any;
  carga3: any;
  contCarga = 8;
  emailFromDom: string = '';
  constructor(
    private _paymentService: PaymentService,
    private route: ActivatedRoute,
    private router: Router,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(
        map((params) => {
          
          this._paymentService.uploadcard = false;
          if (params['uploadCard'] == 'true') {
            this._paymentService.uploadcard = true;
            this.uploadCard = true;
          }
          this.transactionIdentifier = params['transactionIdentifier'];
          this.token = params['token'];
          this.currencySymbol = params['currencySymbol'];

          if (params['country']) {
            localStorage.setItem('country', params['country']);
          } else {
            localStorage.removeItem('country');
          }

          if (params['canEnrAutPay'] != undefined) {
            this.canEnrAutPay = params['canEnrAutPay'];
          }
          if (params['canRegCard'] != undefined) {
            this.canRegCard = params['canRegCard'];
          }
          if (params['payerEmail'] != undefined) {
            this._paymentService.payerEmail = params['payerEmail'];
            this._paymentService.isPayerEmailReadonly = true;
          }
        })
      )
      .subscribe();

    this.loadPage();
  }

  /**
   * Carga el servicio para obtener el contexto del pago, y la sesion de microform para un formulario seguro.
   */
  loadPage(): void {
    this._paymentService
      .loadPayment(this.transactionIdentifier, this.token, this.uploadCard)
      .subscribe((rspOk) => {
        if (rspOk.resultCode === 'SUCCESS') {
          localStorage.setItem('t1_merchant_id', rspOk.result.t1_merchant_id);
          localStorage.setItem('captureContext', rspOk.result.captureContext);
          localStorage.setItem('canRegCard', this.canRegCard);
          localStorage.setItem('canEnrAutPay', this.canEnrAutPay);
          localStorage.setItem('phoneNumber', rspOk.result.phoneNumber);
          localStorage.setItem('channel', rspOk.result.channel);
          localStorage.setItem('id_clpagosclaro', rspOk.result.id_clpagosclaro);
          localStorage.setItem('tipo_seleccion', rspOk.result.tipo_seleccion);
          localStorage.setItem('numerofactura', rspOk.result.numerofactura);
          localStorage.setItem('clnum', rspOk.result.clnum);
          localStorage.setItem('paymentScreenData', JSON.stringify(rspOk.paymentScreenData));  
          localStorage.setItem(
            'onlyLinkAutomaticDebit',
            rspOk.result.onlyLinkAutomaticDebit
          );
          localStorage.setItem('currencySymbol', this.currencySymbol);
          this._paymentService.setMicroformSrc(rspOk.result.microformSrc);
          this._paymentService.setMicroformIntegrity(rspOk.result.integrity);
          this._paymentService.emailFromDom = rspOk.result.emailDomiciliation;
          this._paymentService.numberphone = rspOk.result.phoneNumber;
          this._paymentService.tokeNumero = rspOk.result.toke_numero;
          this._paymentService.arrayLabel = rspOk.result.paymentScreenData;
          this._paymentService.countryCode = rspOk.result.country_code;
          this._paymentService.country = rspOk.result.country;
          localStorage.setItem('email', rspOk.result.emailDomiciliation);
          
          // Inicializar el tema basado en el channel que se acaba de cargar
          this.themeService.reinitializeTheme();
          
          this.router.navigate(['/payment/', 'card-payment']);
        } else if (
          rspOk.resultCode === 'ERROR' &&
          rspOk.errorCode === 'S407VT'
        ) {
          this.router.navigate(['/messages/', 'already-processed']);
        } else if (
          rspOk.resultCode === 'ERROR' &&
          rspOk.errorCode === 'S408VT'
        ) {
          this.router.navigate(['/messages/', 'expired']);
        } else {
          this.router.navigate(['/', '']);
        }
      });
  }

  // loadPageUpdateCard(): void {

  //   this._paymentService
  //     .loadDom(this.token)
  //     // TODO : 200 < 400
  //     .subscribe((rspOk) => {

  //       if (rspOk.resultCode === 'SUCCESS') {
  //         localStorage.setItem('captureContext', rspOk.result.captureContext);
  //         this.router.navigate(['/updateCard/']);
  //       } else {
  //         this.router.navigate(['/', '']);
  //       }
  //     });
  // }

  encryptWithSHA256(message: string): string {
    return CryptoJS.SHA256(message).toString(CryptoJS.enc.Hex);
  }
}
